<template>
  <div class="mt-2">
    <DividerWithText text="Details for dimension and sectors per aggregation level" color="#abc" text-color="#479"/>
    <v-table class="mt-4" hover>
      <colgroup>
        <col />
        <col />
      </colgroup>
      <colgroup>
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th>Name</th>
          <th>Dimension/Sector</th>
          <th>Aggregation Level</th>
          <th>Weight</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(c, index) in combinations"
          :key="`${c.level}_${c.name}`"
          :class="getColor(c.type)"
        >
          <td
            :class="getColor(c.type)"
            :rowspan="rowsPerLevel"
            v-if="index % rowsPerLevel === 0"
            class="border-e-sm"
          >
            <b>{{ StringManipulation.methods.clearAndCapitalize(c.name) }}</b>
          </td>
          <td :rowspan="rowsPerLevel" v-if="index % rowsPerLevel === 0"
          class="border-e-sm"
          >
            {{ StringManipulation.methods.capitalize(c.type) }}
          </td>
          <td class="border-e-sm">
          {{ StringManipulation.methods.clearAndCapitalize(c.level) }}</td>
          <td>{{ c.weight }}</td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script setup>
import StringManipulation from "@/Mixins/StringManipulation";
import { computed } from "vue";
import DividerWithText from "@/Shared/DividerWithText.vue";

const props = defineProps({
  levels: {
    type: Array,
    required: true,
  },
  sectors: {
    type: Array,
    required: true,
  },
  dimension: {
    type: Object,
    required: true,
  },
});

const combinations = computed(() => {
  const levels = props.levels;
  const sectors = props.sectors;
  const dimension = props.dimension;
  let arr = [];

  for (let i = 0; i < sectors.length; i++) {
    const sector = sectors[i];
    for (let l = 0; l < sector.agg.length; l++) {
      const level = sector.agg[l];
      if (levels.includes(level.name)) {
        arr.push({
          level: level.name,
          type: "sector",
          name: sector.name,
          value: level.value,
          weight: level.weight == null ? "-" : level.weight,
        });
      }
    }
  }
  arr = arr.sort((a, b) => (a.name > b.name ? 1 : -1));
  // add dimension combinations
  for (let l = 0; l < dimension.agg.length; l++) {
    const level = dimension.agg[l];
    if (levels.includes(level.name)) {
      arr.unshift({
        level: level.name,
        type: "dimension",
        name: dimension.name,
        value: level.value,
        weight: level.weight,
      });
    }
  }

  return arr;
});

const rowsPerLevel = computed(() => {
  return props.levels.length;
});

function getColor(type) {
  if (type === "dimension") return "primary";
  else return "success";
}
</script>

<style scoped>
.primary {
  background-color: #cfe2ff;
  color: black;
}

.success {
  background-color: #d1e7dd; /* Example success color */
  color: black;
}

::v-deep thead tr th {
  background-color: #4a5876;
  font-weight: bold;
}

::v-deep thead tr {
  color: #fff !important;
}
.hover-cell {
  transition: background-color 0.3s; /* Smooth transition */
}

.hover-cell:hover {
  background-color: rgba(100, 100, 100, 0.1); /* Adjust hover color */
}
</style>
